module.exports = __webpack_public_path__ + "static/media/ancient_greeks_bold.52f725f2.png";